import Lottie from "lottie-web/build/player/lottie_light";

export default class LottieItem extends HTMLElement {

	constructor() {

		super();

		window.Zero.LottieFiles = window.Zero.LottieFiles || [];
		window.Zero.LottieFiles.files = window.Zero.LottieFiles.files || [];

		this.url = this.dataset.url;

		if(!this.url || this.url === ""){
			
			console.log("no Lottie url for ", this); 

			return;
		}

		/** Config */
		this.autoplay = (this.dataset.autoplay === true || this.dataset.autoplay === "true") ? true : false;
		this.framerate = (this.dataset.framerate && this.dataset.framerate !== "") ? this.dataset.framerate : 1;
		this.loop = (this.dataset.loop && this.dataset.loop !== "") ? this.dataset.loop : true;
		this.rendererSettings = {
			progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
			hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
			className: "",
			id: "",
		};

		let fileSplit = this.url.split("?");

		this.fileName = window.btoa(fileSplit[0]);

		/** config our file */
		window.Zero.LottieFiles.files[this.fileName] = window.Zero.LottieFiles.files[this.fileName] || {
			el: this,
			status: "init",
			data: null
		};

		this.dataset.fileName = this.fileName;

		/** Load file */
		this.init();
	}

	async init() {

		/** Detect if a request has already started */
		if(window.Zero.LottieFiles.files[this.fileName].status !== "complete") {

			/** Something here, maybe pause it? */

		}

		/** Check for our JSON load */
		let fileLoaded = await this.checkFile();

		/** Observer */
		let observerOptions = {
			// root: this.parentElement,
			rootMargin: "200px 0px 200px 0px",
			threshold: [0, 0.1] // fire callback when not visible, and visible 10%
		};

		let observerCallback = (entries, observer) => {
		
			entries.forEach((entry) => {

				let fileName = entry.target.dataset.fileName;

				if(!window.Zero.LottieFiles.files[fileName]) return;
				if(entry.isIntersecting || entry.isVisible) window.Zero.LottieFiles.files[fileName].el.runFile();
				if(entry.isVisible === false && window.Zero.LottieFiles.files[fileName].el) window.Zero.LottieFiles.files[fileName].el.pauseOffScreen();
				if(entry.isIntersecting || entry.isVisible) window.Zero.LottieFiles.files[fileName].el.playOnScreen();
			});
		};

		window.Zero.LottieFiles.observer = window.Zero.LottieFiles.observer || new IntersectionObserver(observerCallback, observerOptions);
		window.Zero.LottieFiles.observer.observe(this);
	}

	async checkFile() {

		/** Check if we've stashed in session storage */
		if(window.Zero.LottieFiles.files[this.fileName] && window.Zero.LottieFiles.files[this.fileName].status === "complete") {

			try {

				let json = JSON.parse(window.Zero.LottieFiles.files[this.fileName]);

				return json;

			} catch(err) {

				window.Zero.LottieFiles.files[this.fileName].status = "error";
				window.Zero.LottieFiles.files[this.fileName].data = {};
			}
		}

		/** Send out a fetch for our JSON */
		try {

			window.Zero.LottieFiles.files[this.fileName].status = "loading";

			let data = await fetch(this.url);
			let json = await data.json();
			let parse = JSON.stringify(json);

			window.Zero.LottieFiles.files[this.fileName].status = "complete";
			window.Zero.LottieFiles.files[this.fileName].data = json;

			return parse;

		} catch(err) {

			window.Zero.LottieFiles.files[this.fileName].status = "error";
			window.Zero.LottieFiles.files[this.fileName].data = {
				error: err
			};

			return {};
		}
	}

	/** Gets detatched from Class, put in Observer */
	runFile() {

		if(window.Zero.LottieFiles.files[this.fileName].status !== "complete") return;

		this.animation = Lottie.loadAnimation({
			container: this,
			renderer: this.renderer,
			loop: this.loop,
			autoplay: this.autoplay,
			setSpeed: this.framerate,
			animationData: window.Zero.LottieFiles.files[this.fileName].data,
			rendererSettings: this.rendererSettings
		});

		if(this.autoplay === true) {
			this.playOnScreen();
			window.Zero.LottieFiles.files[this.fileName].status = "running";
		} else {
			window.Zero.LottieFiles.files[this.fileName].status = "paused";
		}
	}

	/** Pause animation */
	pauseOffScreen() {

		if(!this.animation) return;
		
		this.animation.pause();
	}

	/** Play animation if autoplay */
	playOnScreen() {

		if(!this.animation || this.autoplay === false) return;
		
		this.animation.play();
	}
}